import { Box } from "@mui/material";
import { EstimationTable } from "./EstimationTable";

import { useInstrumentation } from "../../InstrumentationContext";

// The revision picker moved into the page header (Rev. dropdown), so this tab
// just reads whichever revision the user confirmed there.
export function EstimationTab() {
  const { selectedEstimationRevision } = useInstrumentation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        gap: 2,
      }}
    >
      <Box>
        <EstimationTable revision={selectedEstimationRevision} />
      </Box>
    </Box>
  );
}
